// extracted by mini-css-extract-plugin
export default {"cta":"zG-z","disabled":"AG-z"};